import axios from 'axios';
import Cookies from 'js-cookie';

var cookieVar = 'brochure-access';
var currentTarget;
var brochureURL;

function modalOpener() {
    $('.js-brochure-download').click(function(e) {
        e.preventDefault();

        let clicked = $(e.target);
        currentTarget = clicked.closest('.js-brochure-download');
        brochureURL = getFilePath(currentTarget);
        let remodal = getModal().remodal();

        if(Cookies.get(cookieVar)) {
            downloadFile(getFilePath(currentTarget));
        } else {
            remodal.open();
        }
    })
}

function submissionHandler() {
    let form = $('#ne-brochure-modal form');

    form.submit((e) => {
        e.preventDefault();

        let values = form.serializeArray();
        let action = '/actions/groupfirst/api/deliver';
        let params = urlParams(values, brochureURL);
        let config = { headers: {'Content-Type': 'multipart/form-data' }};

        axios.post(action, params, config).then((response) => {
            if(response.data.status === 'success') {
                Cookies.set(cookieVar, true, { expires: 7 });
                getModal().remodal().close();
                downloadFile(getFilePath(currentTarget));
            } else {
                let msg = '<p><strong> ' +
                            'Sorry, there was a problem. Please try again or contact support for assistance ' +
                          '</strong> </p>';
                form.prepend(msg);
            }
        })
    })
}

function urlParams(form, brochureLink) {
    let params = new FormData();

    Object.entries(form)
        .forEach((p) =>  {
            params.set(p[1].name, p[1].value);
        });

    params.set('source', 'Download Brochure');
    params.set('brochureURL', brochureLink);

    return params;
}

function handleBrochureDownload() {
    modalOpener();
    submissionHandler();
}

function getFilePath(target) {
    return $(target).data('data');
}

function getModal() {
    return $('[data-remodal-id=ne-brochure-modal]');
}

/**
 * Append/remove required for Firefox.
 *
 * @param filePath
 */
function downloadFile(filePath){
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafari && iOS) {
        window.location.assign(filePath);
    } else {
        openFileAsDownload(filePath);
    }
}

function openFileAsDownload(filePath) {
    var link=document.createElement('a');
    link.className = 'tempBrochureDownloadLink';
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default handleBrochureDownload;
